export const ASSISTED_LIVE_STATUS_TABS = [
  {
    name: 'Video Upload History',
    to: 'video-upload-history',
  },
  {
    name: 'Bulk Upload Video',
    to: 'upload-video',
  },
];
